import { Routes } from '@angular/router';
import { ComparePage } from './compare-page/compare-page';
import { CrossPage } from './cross-page/cross-page';
import { LoginPage } from './login-page/login-page';
import { OverviewPage } from './overview-page/overview-page';
import { redirectIfSignedIn, sourceAuthGuard } from './source-auth.guard';
import { WorkspacePage } from './workspace-page/workspace-page';

export const routes: Routes = [
  { path: 'login', component: LoginPage, canActivate: [redirectIfSignedIn] },
  {
    path: '',
    component: WorkspacePage,
    canActivate: [sourceAuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'compare' },
      { path: 'compare', component: ComparePage },
      { path: 'overview', component: OverviewPage },
      { path: 'cross', component: CrossPage },
    ],
  },
  { path: '**', redirectTo: '/compare' },
];
